import React from "react";
import { FaDownload } from "react-icons/fa";
import "./Rightsidebar.css";
import {
  FaCalendarAlt,
  FaMars,
  FaVenus,
  FaPhoneAlt,
  FaShieldAlt,
} from "react-icons/fa";

const Rightsidebar = ({ selectedPatient }) => {
  if (!selectedPatient) {
    return (
      <div className="right-sidebar">
        <h3>Select a Patient</h3>
      </div>
    );
  }

 

  const handleDownload = (file) => {
    alert(`Downloading: ${file}`);
  };

  return (
    <div className="right-sidebar">
      <img
        src={selectedPatient.profile_picture}
        alt={selectedPatient.name}
        className="patient-image"
      />
      <h3 className="patient-name">{selectedPatient.name}</h3>
      <div className="patient-info">
        <div className="info-item">
          <FaCalendarAlt className="icon" />

          <p>
            <span id="info-label">DOB:</span>
            <span id="info-value">
              {selectedPatient.date_of_birth || "N/A"}
            </span>
          </p>
        </div>
        <div className="info-item">
          <FaMars className="icon" /> 
          <p>
            <span id="info-label">Gender:</span>
            <span id="info-value">
              {selectedPatient.gender || "N/A"}
            </span>
          </p>
        </div>
        <div className="info-item">
          <FaPhoneAlt className="icon" />
          <p>
            <span id="info-label">Contact:</span>
            <span id="info-value">
              {selectedPatient.phone_number || "N/A"}
            </span>
          </p>
        </div>
        <div className="info-item">
          <FaPhoneAlt className="icon" />
          <p>
            <span id="info-label">Emergency Contact:</span>
            <span id="info-value">
              {selectedPatient.emergency_contact || "N/A"}
            </span>
          </p>
        </div>
        <div className="info-item">
          <FaShieldAlt className="icon" />
          <p>
            <span id="info-label">Insurance No:</span>
            <span id="info-value">
              {selectedPatient.insurance_type || "N/A"}
            </span>
          </p>
        </div>
      </div>

      <div className="lab-reports">
        <h4>Lab Results</h4>
        <ul>
          {selectedPatient.lab_results.map((report, id) => (
            <li key={report.id} className="lab-report-item">
              <span className="report-name">{report.substr(0,4)}</span>
              <button
                className="download-btn"
                onClick={() => handleDownload(report.file)}
              >
                <FaDownload /> Download
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Rightsidebar;
